/**
 * keys.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Pipe, PipeTransform } from "@angular/core";

/**
 * {@link KeysPipe} returns the string keys of an object.
 *
 * NOTE: This pipe is marked pure, so it may not update on change. Our usage is
 * limited and this keeps it from being a performance hit.
 */
@Pipe({
  name: "keys"
})
export class KeysPipe implements PipeTransform
{
    public transform (obj : {[key : string] : any}) : string[]
    {
        return Object.keys(obj);
    }
}

/**
 * {@link KeysPipe} returns the key-value paired entries of an object.
 *
 * NOTE: This pipe is marked pure, so it may not update on change. Our usage is
 * limited and this keeps it from being a performance hit.
 */
@Pipe({
    name: "entries"
})
export class EntriesPipe implements PipeTransform
{
    public transform (obj : {[key : string] : any})
        : Array<[string, any]>
    {
        return Object.entries(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/keys.pipe.ts